import { getBackendURL } from "../components/env";

/**
 * Delete files from Supabase storage and clean up their file_classification_cache entries.
 * Use this instead of raw supabase.storage.remove() whenever deleting report/document files
 * so that fax inbox entries stay in sync.
 *
 * @param {object} supabase - Supabase client instance
 * @param {string} bucketName - Storage bucket name
 * @param {string[]} filePaths - Array of file paths to delete
 * @returns {{ removed: string[], errors: string[] }}
 */
export const deleteFilesWithCacheCleanup = async (supabase, bucketName, filePaths) => {
  const removed = [];
  const errors = [];

  // Delete from storage
  const { error } = await supabase.storage
    .from(bucketName)
    .remove(filePaths);

  if (error) {
    console.error("Error deleting files from storage:", error);
    errors.push(...filePaths);
    return { removed, errors };
  }

  removed.push(...filePaths);

  // Clean up file_classification_cache entries via the backend API
  // (the backend has the service role key to bypass RLS)
  const baseUrl = getBackendURL();
  for (const filePath of filePaths) {
    try {
      await fetch(`${baseUrl}/api/fax/delete/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ file_path: filePath }),
      });
    } catch (cacheErr) {
      // Non-fatal — file is already removed from storage
      console.warn(`Could not clean up cache entry for ${filePath}:`, cacheErr);
    }
  }

  return { removed, errors };
};
